import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function PageHero({ eyebrow, title, desc, image, crumb }) {
  return (
    <section className="relative overflow-hidden bg-[#0B132B] pt-32 pb-20">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" className="h-full w-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0B132B] via-[#0B132B]/90 to-[#0B132B]/50" />
        </div>
      )}
      <div className="absolute inset-0 aje-grid-bg opacity-25" />
      <div className="absolute -right-10 top-10 h-56 w-56 rounded-full bg-emerald-500/15 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.nav
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-5 flex items-center gap-1.5 text-sm text-slate-400"
        >
          <Link to="/" className="hover:text-emerald-400">Beranda</Link>
          <ChevronRight className="h-4 w-4" />
          <span className="text-emerald-400">{crumb}</span>
        </motion.nav>
        {eyebrow && (
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.05 }}
            className="aje-eyebrow mb-3"
          >
            {eyebrow}
          </motion.p>
        )}
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-white max-w-3xl"
        >
          {title}
        </motion.h1>
        {desc && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="mt-5 max-w-2xl text-lg leading-relaxed text-slate-300"
          >
            {desc}
          </motion.p>
        )}
      </div>
    </section>
  );
}
